import { ClaimControllerApi } from "../../../services";
import { useDownloadReport } from "../../../hooks/use-download-report";
import { formatDateTime } from "../../../utils/date-time-utility";
import { getConfigObject, getXtenantId } from "../../../utils/utils";

export const useClaimExportCsv = () => {
  const { download } = useDownloadReport();

  const exportClaimsCsv = (claimUuids: string[]) => {
    download({
      apiCall: new ClaimControllerApi(getConfigObject()).exportClaimsCsv(
        claimUuids,
        getXtenantId(),
        { responseType: "arraybuffer" }
      ),
      fileName: `Billing_Report ${formatDateTime(new Date())}.csv`,
      contentType: "text/csv",
    });
  };

  return { exportClaimsCsv };
};
